/*
 * @Author: cryi.liu
 * @Date: 2020-04-30 14:32:57
 * @LastEditTime: 2020-04-30 14:34:32
 * @Description: 原 pss 风格 footer 状态管理
 */

export default {
  namespaced: true,

  state: {
    // 协议显示状态
    statement: {
      show: false,
    },
  },

  getters: {
    // get 协议显示状态
    statementShowState({ statement }) {
      return statement.show;
    },
  },

  mutations: {
    // set 协议显示状态
    setStatementShowState(state, { show }) {
      state.statement.show = show;
    },
  },

  actions: {
    invokeSetStatementShowState({ commit }, payload) {
      commit('setStatementShowState', payload);
    },
  },
};
